import styles from "./Focus.module.css";

const Focus = () => {
  return (
    <div className={`generic-page children-middle txt-center`}>
      <h1>We're in the process of integrating a pomodoro feature for Zariya. Focus mode is coming soon</h1>
    </div>
  )
}

export default Focus